import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TTelemetryResponseRTs,
  TImgResponseRTs,
  TStreetsResponseRTs,
  TSegmentsLastHourResponseRTs,
  TEventsResponseRTs,
  TPhasesResponseRTs,
  TKtsHoursResponseRTs,
  TSoHoursResponseRTs,
} from 'response/RTsResponce';

type TRTc = {
  isFetching: boolean;
  error: string;
  rts_telemetry: TTelemetryResponseRTs;
  rts_image: TImgResponseRTs;
  rts_streets: TStreetsResponseRTs;
  rts_kts_last_hour: TSegmentsLastHourResponseRTs;
  rts_events_last: TEventsResponseRTs;
  rts_events_alls: TEventsResponseRTs;
  rts_get_phase: TPhasesResponseRTs;
  rts_kts_hours: TKtsHoursResponseRTs;
  rts_so_hours: TSoHoursResponseRTs;
};

const initialState: TRTc = {
  isFetching: false,
  error: '',
  rts_telemetry: {
    oID: '',
    online: false,
    configuration: false,
    error: false,
    io_port: 'Нет данных',
    dk: 'Нет данных',
    control_dkso: 'Нет данных',
    control_rts: 'Нет данных',
    state_control_rts: 'Нет данных',
    phase: 0,
    phase_sequence: 'Нет данных',
    phase_durations: 'Нет данных',
    need_restart: false,
    online_time: 0,
    blink: true,
    vprocessor_oID: '',
  },
  rts_image: {
    oID: '',
    img: '',
  },
  rts_streets: {
    oID: '',
    streets: {},
    directions: {},
  },
  rts_kts_last_hour: {
    oID: '',
    data: [
      {
        oID: '',
        KTS: 0,
        KTK: 0,
        KTD: 0,
        KTP: 0,
        speed: 0,
      },
    ],
  },
  rts_events_last: {
    oID: '',
    events: [
      {
        utime: 0,
        status: '',
        msg: '',
      },
    ],
  },
  rts_events_alls: {
    oID: '',
    events: [
      {
        utime: 0,
        status: '',
        msg: '',
      },
    ],
  },
  rts_get_phase: {
    phases: {},
  },
  rts_kts_hours: {
    oID: '',
    data: [
      {
        utime: 0,
        kts_value: 0,
      },
    ],
  },
  rts_so_hours: {
    oID: '',
    data: [
      {
        utime: 0,
        so_value: 0,
      },
    ],
  },
};

export const rtsSlice = createSlice({
  name: 'rts',
  initialState,
  reducers: {
    // rts start
    rtsFetching(state) {
      state.isFetching = true;
    },
    // rts succes
    rtsSuccesTelemety(state, action: PayloadAction<TTelemetryResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_telemetry = action.payload;
    },
    rtsSuccesImg(state, action: PayloadAction<TImgResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_image = action.payload;
    },
    rtsSuccesStreets(state, action: PayloadAction<TStreetsResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_streets = action.payload;
    },
    rtsSuccesKtsLastHour(state, action: PayloadAction<TSegmentsLastHourResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_kts_last_hour = action.payload;
    },
    rtsSuccesEventsLast(state, action: PayloadAction<TEventsResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_events_last = action.payload;
    },
    rtsSuccesEventsAlls(state, action: PayloadAction<TEventsResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_events_alls = action.payload;
    },
    rtsSuccesPhase(state, action: PayloadAction<TPhasesResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_get_phase = action.payload;
    },
    rtsSuccesKtsHours(state, action: PayloadAction<TKtsHoursResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_kts_hours = action.payload;
    },
    rtsSuccesSoHours(state, action: PayloadAction<TSoHoursResponseRTs>) {
      state.isFetching = false;
      state.error = '';
      state.rts_so_hours = action.payload;
    },
    // rts error
    rtsError(state, action: PayloadAction<string>) {
      state.isFetching = false;
      state.error = action.payload;
    },
    // rtc reset
    rtcReset() {
      return initialState;
    },
  },
});

export default rtsSlice.reducer;
